function SzemelyAdatokIcon({ size, fill }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size || 24}
      height={size || 24}
      viewBox="0 -960 960 960"
      fill={fill}
    >
      <path d="M560-680v-80h320v80zm0 160v-80h320v80zm0 160v-80h320v80zm-240-40q-50 0-85-35t-35-85 35-85 85-35 85 35 35 85-35 85-85 35M80-160v-76q0-21 10-40t28-30q45-27 95.5-40.5T320-360t106.5 13.5T522-306q18 11 28 30t10 40v76zm86-80h308q-35-20-74-30t-80-10-80 10-74 30m154-240q17 0 28.5-11.5T360-520t-11.5-28.5T320-560t-28.5 11.5T280-520t11.5 28.5T320-480m0 240" />
    </svg>
  );
}

export default SzemelyAdatokIcon;
